import { get } from 'lodash';
import { useCampaignsFormFieldValue } from '../../../hooks';

export const useCreateFormSelectedCampaignId = () => {
    const { value: campaigns = [] } = useCampaignsFormFieldValue();
    return get(campaigns, [0, 'id']);
};
